import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { IndicatorSelection, LayerProperties } from "../../types";
import { LegendItemSkeleton } from "../skeletons/LegendItemSkeleton";
import { LegendLoad } from "./LegendLoad";

interface Props {
  config: string;
  selection: IndicatorSelection[];
  layerProperties: LayerProperties[];
}

export function Legend(props: Props) {
  const { config, selection, layerProperties } = props;

  return (
    <>
      {selection
        .filter((isActive) => isActive.active)
        .map((currentSelection) => (
          <ErrorBoundary
            key={`legend-load-error-${currentSelection.indicatorId}`}
            fallbackRender={() => null}
          >
            <Suspense fallback={<LegendItemSkeleton />}>
              <LegendLoad
                config={config}
                selection={currentSelection}
                layerProperties={layerProperties}
              />
            </Suspense>
          </ErrorBoundary>
        ))}
    </>
  );
}
